import NotFound from 'components/NotFound';
import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import ViewBookingsPanel from './ViewBookingsPanel';

const BookingsContainer = ({ history }) => {
  return (
    <ConnectedRouter history={history}>
      <Switch>
        <Route path={``} component={ViewBookingsPanel} exact />
        <Route component={NotFound} />
      </Switch>
    </ConnectedRouter>
  );
};

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(BookingsContainer);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/Bookings/index.jsx